import React from'react';import PropTypes from'prop-types';import {useIntl}from'react-intl';import styled from'styled-components';import {BREAKPOINTS,useMedia,ProgressBar,PROGRESS_BAR_VARIANT,MessageCard,H1,MESSAGE_VARIANT}from'@manulife/mux';import muxCustomStyles from'../../../customStyles/index.js';import {ProgressBarShape}from'../../../utils/propTypes.js';import defaultBackground from'../../../assets/images/background-lighthouse.jpg.js';import useCoBranding from'../../../hooks/useCoBranding.js';import CoBrandingLogo from'../../CoBranding/CoBrandingLogo.js';var COLUMN_WIDTH = 80.8;
var COLUMN_GUTTER = 30;
var PageWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "ContentPage__PageWrapper",
  componentId: "sc-1bcibrd-0"
})(["height:100%;display:flex;flex-direction:row;"]);
var PageContent = /*#__PURE__*/styled.div.withConfig({
  displayName: "ContentPage__PageContent",
  componentId: "sc-1bcibrd-1"
})(["max-width:100%;height:100%;width:1107px;overflow:hidden;background-color:", ";"], function (props) {
  return props.backgroundColor || props.theme.colorPalette.neutralColors.light.shade_white;
});
var PageMain = /*#__PURE__*/styled.main.withConfig({
  displayName: "ContentPage__PageMain",
  componentId: "sc-1bcibrd-2"
})(["padding:0 1rem 1rem 1rem;max-width:", ";overflow:hidden;display:block;@media (min-width:", "px){margin-left:133px;}"], function (_ref) {
  var isTablet = _ref.isTablet,
    contentColumns = _ref.contentColumns;
  return isTablet ? '409px' : "".concat(Math.round(contentColumns * (COLUMN_WIDTH + COLUMN_GUTTER) - COLUMN_GUTTER), "px");
}, BREAKPOINTS.PHONE_PORTRAIT_LG);
var SideImage = /*#__PURE__*/styled.div.withConfig({
  displayName: "ContentPage__SideImage",
  componentId: "sc-1bcibrd-3"
})(["background-color:", ";background-image:url(", ");background-repeat:no-repeat;background-position:center bottom;background-size:cover;position:fixed;left:1207px;width:calc(100% - 1207px);height:100%;z-index:-1;"], function (props) {
  return props.backgroundColor || props.theme.colorPalette.primaryColors.main.shade_default;
}, function (props) {
  return props.backgroundImage;
});
function ContentPage(_ref2) {
  var _cobranding$images;
  var isLoggedOut = _ref2.isLoggedOut,
    signoutMessage = _ref2.signoutMessage,
    signoutMessageVariant = _ref2.signoutMessageVariant,
    heading = _ref2.heading,
    children = _ref2.children,
    contentBackgroundColor = _ref2.contentBackgroundColor,
    backgroundColor = _ref2.backgroundColor,
    backgroundImage = _ref2.backgroundImage,
    topProgressbar = _ref2.topProgressbar,
    backButton = _ref2.backButton,
    contentColumns = _ref2.contentColumns;
  var intl = useIntl();
  var cobranding = useCoBranding();
  var isTablet = useMedia(["(max-width: ".concat(BREAKPOINTS.TABLET_PORTRAIT, "px)")], [true], false);
  var isMobile = useMedia(["(max-width: ".concat(BREAKPOINTS.MAX_1024, "px)")], [true], false);
  return /*#__PURE__*/React.createElement(PageWrapper, null, /*#__PURE__*/React.createElement(PageContent, {
    backgroundColor: contentBackgroundColor
  }, /*#__PURE__*/React.createElement(CoBrandingLogo, {
    hideManulife: isMobile
  }), /*#__PURE__*/React.createElement(PageMain, {
    isTablet: isTablet,
    contentColumns: contentColumns
  }, backButton, (topProgressbar === null || topProgressbar === void 0 ? void 0 : topProgressbar.progressPerc) && /*#__PURE__*/React.createElement(ProgressBar, {
    customStyle: muxCustomStyles.topProgressbar,
    completionText: intl.formatMessage({
      id: 'shared.progressBar.complete'
    }),
    progressPerc: topProgressbar.progressPerc,
    variant: PROGRESS_BAR_VARIANT.PERCENTAGE
  }), (topProgressbar === null || topProgressbar === void 0 ? void 0 : topProgressbar.currentStep) && /*#__PURE__*/React.createElement(ProgressBar, {
    currentStep: topProgressbar.currentStep,
    customStyle: muxCustomStyles.topProgressbar,
    steps: topProgressbar.steps,
    variant: PROGRESS_BAR_VARIANT.STEPS
  }), isLoggedOut && /*#__PURE__*/React.createElement(MessageCard, {
    id: "signout-message",
    variant: signoutMessageVariant,
    "aria-live": "assertive",
    role: "alert"
  }, signoutMessage), /*#__PURE__*/React.createElement(H1, {
    disableFocusOutline: true
  }, heading), children)), /*#__PURE__*/React.createElement(SideImage, {
    backgroundColor: backgroundColor,
    backgroundImage: backgroundImage || (cobranding === null || cobranding === void 0 ? void 0 : (_cobranding$images = cobranding.images) === null || _cobranding$images === void 0 ? void 0 : _cobranding$images.sideImageUrl) || defaultBackground
  }));
}
process.env.NODE_ENV !== "production" ? ContentPage.propTypes = {
  heading: PropTypes.node,
  children: PropTypes.node,
  contentBackgroundColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  backgroundImage: PropTypes.string,
  topProgressbar: ProgressBarShape,
  signoutMessage: PropTypes.node,
  signoutMessageVariant: PropTypes.string,
  isLoggedOut: PropTypes.bool,
  backButton: PropTypes.node,
  contentColumns: PropTypes.number
} : void 0;
ContentPage.defaultProps = {
  heading: '',
  children: '',
  contentBackgroundColor: null,
  backgroundColor: null,
  backgroundImage: null,
  topProgressbar: null,
  signoutMessage: '',
  signoutMessageVariant: MESSAGE_VARIANT.SECONDARY_COMPLETE,
  isLoggedOut: false,
  backButton: null,
  contentColumns: 6
};export{ContentPage as default};